import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Duplicate } from '../../model/duplicate';

@Component( {
    selector: 'res-display-duplicates',
    templateUrl: './display-duplicates.component.html',
} )
export class DisplayDuplicatesComponent {
    @Input() duplicatesMessageSuffix: string;
    @Input() duplicates: Duplicate[] = [];
    @Input() route: string;

    @Output() linkClicked = new EventEmitter();

    constructor() {}

    public onClick() {
        this.linkClicked.emit();
    }
}
